import { useState } from "react";
import * as XLSX from "xlsx";
import "./ReconMatchHeader.css";
import { returnPayoutIds } from "../../../config/LiveApi";

function ReconMatchHeader() {
  const [refIds, setRefIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [records, setRecords] = useState([]);

  // 📂 Read Excel
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet);

      const extractedRefIds = json
        .map((row) => row.RefId || row.refId || row.referenceId || row.REF_ID)
        .filter(Boolean);

      setRefIds(extractedRefIds);
      setLogs([`✅ Extracted ${extractedRefIds.length} Reference IDs`]);
      setRecords([]);
    };

    reader.readAsBinaryString(file);
  };

  // 🚀 Start Recon (ONE BY ONE)
  const startRecon = async () => {
    if (!refIds.length) {
      alert('No Reference IDs found');
      return;
    }

    setLoading(true);
    setLogs(['⏳ Recon started...']);
    setRecords([]);

    let finalRecords = [];
    let checked = 0;
    let failed = 0;

    for (const refId of refIds) {
      try {
        checked++;
        setLogs((prev) => [...prev, `🔍 Processing ${refId}`]);

        const res = await returnPayoutIds(refId);

        const apiData = res.data?.data;

        if (apiData?.records?.length) {
          finalRecords.push(...apiData.records);
        }
      } catch (err) {
        failed++;
        setLogs((prev) => [...prev, `❌ Failed for ${refId}`]);
      }
    }

    setLogs((prev) => [
      ...prev,
      `✅ Checked: ${checked}`,
      `❌ Failed: ${failed}`,
      `🎯 Returned: ${finalRecords.length}`,
    ]);

    setRecords(finalRecords);
    setLoading(false);
  };

  // 📥 Download Excel
  const downloadExcel = () => {
    if (!records.length) return;

    const worksheet = XLSX.utils.json_to_sheet(records);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Recon_Result");
    XLSX.writeFile(workbook, "recon_result.xlsx");
  };

  return (
    <div className="recon-container">
      <h2 className="recon-title">🔍 Recon Match</h2>

      <div className="upload-box">
        <input
          className="recon-file-input"
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileUpload}
        />

        <button
          className="recon-btn primary-btn"
          onClick={startRecon}
          disabled={loading}
        >
          {loading ? "Processing..." : "Start Recon"}
        </button>

        <button
          className="recon-btn download-btn"
          onClick={downloadExcel}
          disabled={!records.length}
        >
          Download Excel
        </button>
      </div>

      <div className="logs">
        <h4 className="logs-title">Logs</h4>
        <ul className="logs-list">
          {logs.map((log, index) => (
            <li key={index} className="log-item">
              {log}
            </li>
          ))}
        </ul>
      </div>

      {records.length > 0 && (
        <div className="table-wrapper">
          <h4 className="table-title">Recon Result</h4>

          <table className="recon-table">
            <thead className="recon-table-head">
              <tr>
                <th>Reference ID</th>
                <th>Order ID</th>
                <th>Transaction ID</th>
                <th>Type</th>
                <th>UTR</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody className="recon-table-body">
              {records.map((row, idx) => (
                <tr key={idx} className="recon-table-row">
                  <td>{row.referenceId}</td>
                  <td>{row.requestOrderId}</td>
                  <td>{row.transactionId}</td>
                  <td>{row.type}</td>
                  <td>{row.responseUTR || "-"}</td>
                  <td>{row.requestAmount}</td>
                  <td>
                    <span className={`status-badge ${row.responseStatus}`}>
                      {row.responseStatus}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ReconMatchHeader;
